import { render, staticRenderFns } from "./presentationMpago.vue?vue&type=template&id=75e2f711&"
import script from "./presentationMpago.vue?vue&type=script&lang=js&"
export * from "./presentationMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports